import axiosHttp from "./interceptor.service";

const getTicket = ({
  sort,
  search,
  limit,
  page,
  isAssigned,
  isManagement,
  isRead,
  assignedTo,
  ticketStatus,
  progressStatus,
  startDate,
  endDate,
  assignedStartDate,
  assignedEndDate,
  supportTicket,
  updatedStartDate,
  updatedEndDate,
  closedStartDate,
  closedEndDate,
  isExpired,
  sendStatus,
  timerRangeType,
  timerStatus,
  assignedDepartmentId,
  timerType,
} = {}) => {
  return axiosHttp.get("/feedback/getTicket", {
    params: {
      sort,
      search,
      limit,
      page,
      isAssigned,
      isManagement,
      isRead,
      assignedTo,
      supportTicket,
      ticketStatus,
      progressStatus,
      startDate,
      endDate,
      assignedStartDate,
      assignedEndDate,
      updatedStartDate,
      updatedEndDate,
      closedStartDate,
      closedEndDate,
      isExpired,
      sendStatus,
      timerType,
      timerRangeType,
      assignedDepartmentId,
      timerStatus,
    },
  });
};

const getTicketChat = ({
  sort,
  search,
  limit,
  page,
  isAssigned,
  isManagement,
  isRead,
  assignedTo,
  ticketStatus,
  progressStatus,
  startDate,
  endDate,
  supportTicket,
  assignedStartDate,
  assignedEndDate,
  updatedStartDate,
  updatedEndDate,
  closedStartDate,
  closedEndDate,
  isExpired,
  sendStatus,
  timerRangeType,
  timerStatus,
  assignedDepartmentId,
  timerType,
} = {}) => {
  return axiosHttp.get("/feedback/getTicketChat", {
    params: {
      sort,
      search,
      limit,
      page,
      isAssigned,
      isManagement,
      isRead,
      assignedTo,
      ticketStatus,
      progressStatus,
      startDate,
      endDate,
      supportTicket,
      assignedStartDate,
      assignedEndDate,
      updatedStartDate,
      updatedEndDate,
      closedStartDate,
      closedEndDate,
      isExpired,
      sendStatus,
      timerType,
      timerRangeType,
      assignedDepartmentId,
      timerStatus,
    },
  });
};

const createTicket = (data) => {
  return axiosHttp.post("/feedback/createDirectTicket", data);
};

const addConversation = (ticketId, data) => {
  return axiosHttp.put(`/feedback/addConversation/${ticketId}`, data);
};
const getChatConversation = (ticketId, data) => {
  return axiosHttp.get(`/feedback/getChatConversationWeb/${ticketId}`, data);
};

const closeTicket = (ticketId, data) => {
  return axiosHttp.put(`/feedback/updateTicketStatus/${ticketId}`, data);
};
const alertCloseMessage = (data) => {
  return axiosHttp.put(`/feedback/alertMessageToCloseChat`, data);
};

const updateTicket = (id, data) => {
  return axiosHttp.put(`/feedback/updateTicket/${id}`, data);
};

const getTicketExpiryHistory = (id) => {
  return axiosHttp.get(`/feedback/ticketExpiryHistory/${id}`);
};

const extendTicketExpiry = (id, data) => {
  return axiosHttp.put(`/feedback/extendTicketExpiry/${id}`, data);
};

const deleteTicket = (id) => {
  return axiosHttp.delete(`/feedback/deleteTicket/${id}`);
};

const publicHolidays = () => {
  return axiosHttp.get("/feedback/publicholiday");
};

const callMailFunctApi = () => {
  return axiosHttp.get("/feedback/callMailToMail");
};

export {
  getTicket,
  getTicketChat,
  createTicket,
  addConversation,
  getChatConversation,
  closeTicket,
  alertCloseMessage,
  updateTicket,
  getTicketExpiryHistory,
  extendTicketExpiry,
  deleteTicket,
  publicHolidays,
  callMailFunctApi,
};
